import { render, staticRenderFns } from "./startByKey.vue?vue&type=template&id=c1dbfd9e&scoped=true&"
import script from "./startByKey.vue?vue&type=script&lang=js&"
export * from "./startByKey.vue?vue&type=script&lang=js&"
import style0 from "./startByKey.vue?vue&type=style&index=0&id=c1dbfd9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1dbfd9e",
  null
  
)

export default component.exports